var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHidePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.97712 0L0.87793 1.08126L15.0226 15L16.1218 13.9184L1.97712 0Z",
    fill: "#9A9DA0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.20032 3.36632L4.23492 4.38437C3.10236 5.33326 2.20051 6.5144 1.61773 7.54781L1.61595 7.5513C3.23901 10.2216 5.81431 12.7453 9.06468 12.3625C9.94204 12.2591 10.7605 11.964 11.5083 11.5418L12.5557 12.572C11.098 13.4926 9.42705 13.9802 7.6166 13.7392C4.35204 13.3047 1.68268 10.67 0 7.57575C0.790054 6.01149 1.87079 4.51498 3.20032 3.36632ZM5.55345 1.85759C6.4663 1.45736 7.45405 1.22197 8.50887 1.2052C8.56744 1.20485 9.26273 1.23733 9.5779 1.28832C9.77559 1.32045 9.97257 1.36062 10.1667 1.41056C13.2634 2.20439 15.5576 4.78041 17 7.43431C16.3949 8.63675 15.6023 9.81021 14.6572 10.8157L13.6538 9.82837C14.3519 9.08797 14.934 8.26376 15.3823 7.46434C15.3823 7.46434 14.9315 6.75119 14.5897 6.30346C14.37 6.01568 14.139 5.73629 13.8962 5.46702C13.7046 5.25468 12.9603 4.53349 12.7832 4.38332C11.5949 3.37785 10.1997 2.58891 8.52626 2.60218C7.87818 2.6123 7.25494 2.73803 6.66328 2.94967L5.55345 1.85759Z",
    fill: "#9A9DA0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.0168 6.13802L6.81548 6.9236L9.8897 9.94862C9.4787 10.1756 9.00453 10.3048 8.50019 10.3048C6.92966 10.3048 5.65479 9.05036 5.65479 7.50496C5.65479 7.00869 5.78646 6.54245 6.0168 6.13802ZM8.44766 4.70578C8.46505 4.70543 8.48279 4.70508 8.50019 4.70508C10.0707 4.70508 11.3456 5.95991 11.3456 7.50496C11.3456 7.52242 11.3456 7.53954 11.3452 7.55665L8.44766 4.70578Z",
    fill: "#9A9DA0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePassword);
export default __webpack_public_path__ + "static/media/hidePassword.aa7a697f173397214c99c46dd488ccca.svg";
export { ForwardRef as ReactComponent };